var applyOffset = function (from, to) {
    var hasReceivedFrom = true;
    if (to === undefined) {
        to = from;
        hasReceivedFrom = false;
    }
    return function (v) {
        if (hasReceivedFrom) {
            return v - from + to;
        }
        else {
            from = v;
            hasReceivedFrom = true;
            return to;
        }
    };
};

export { applyOffset };



//////////////////
// WEBPACK FOOTER
// ./node_modules/popmotion/dist/es/utils/apply-offset.js
// module id = null
// module chunks = 